<template>
	<div class="flex justify-between items-center gap-5 w-full lg:w-auto min-h-[2rem] p-5 bg-gradient-blue rounded-t-md">
		<div class=" lg:w-auto flex items-center text-gray-50">
			<p v-if="slots.icon" class="mr-3">
				<slot name="icon"></slot>
			</p>
			<div class="font-medium text-left flex flex-row items-center gap-2 w-full lg:w-auto">
				<slot name="text"></slot>
			</div>
		</div>
		<div v-if="slots.actions" class="flex flex-wrap lg:flex-row justify-end items-center w-auto relative gap-2">
			<slot name="actions"></slot>
		</div>
	</div>
</template>

<script setup>
	import { useSlots } from 'vue';

	const slots = useSlots();
</script>
